import { Route, Routes } from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import RegistrationPage from "./pages/auth/RegistrationPage";
import AdminDashboard from "./pages/Admin/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import PlansPage from "./pages/PlansPage";
// import { useAppSelector } from "./hooks";
import NotFoundPage from "./pages/NotFoundPage";
import AdminStoresPage from "./pages/Admin/Stores";
import SetPasswordPage from "./pages/auth/SetPasswordPage";
import ForgotPasswordPage from "./pages/auth/ForgotPasswordPage";
import ManagerLayout from "./pages/Manager/Layout";
import CashierLayout from "./pages/Cashier/Layout";
import MorePage from "./pages/More";
import AdminLayout from "./pages/Admin/Layout";
import ManagerDashboard from "./pages/Manager/Dashboard";
import SubscriptionPage from "./pages/Subscription";
import ManagerStoreItemsPage from "./pages/Manager/Items";
// import { RoleBasedLayout } from "./components/RoleBasedLayout";
import CashierItemsPage from "./pages/Cashier/Items";
import CashierCustomersPage from "./pages/Cashier/Customers";
import CashierDashboard from "./pages/Cashier/Dashboard";
import NotificationsPage from "./pages/Notifications";
import EmployeesPage from "./pages/Employees";
import SalesHistoryPage from "./pages/SalesHistory";
import ProductSalesHistoryPage from "./pages/ProductSalesHistoryPage";
import TestSMSPage from "./pages/TestSMS";
import LandingPage from "./pages/Landing";
import SettingsPage from "./pages/Settings";
import { AuthGate } from "./AuthGate";
import OnboardingPage from "./pages/Onboarding";
import SuperAdminLogin from "./pages/SuperAdmin/Login";
import SuperAdminDashboard from "./pages/SuperAdmin/Dashboard";
import SuperAdminUsers from "./pages/SuperAdmin/Users";
import SuperAdminBusinesses from "./pages/SuperAdmin/Businesses";
import SuperAdminStores from "./pages/SuperAdmin/Stores";
import SuperAdminSubscriptions from "./pages/SuperAdmin/Subscriptions";
import SuperAdminAuditLog from "./pages/SuperAdmin/AuditLog";
import SuperAdminUserDetail from "./pages/SuperAdmin/UserDetail";
import SuperAdminBusinessDetail from "./pages/SuperAdmin/BusinessDetail";
import SuperAdminRoute from "./components/SuperAdminRoute";


const AppRoutes = () => {

    // const userDetails = useAppSelector((state) => state.auth);
    // const userRole = userDetails?.activeRole;

    return ( 
        // <Routes>
        //     <Route 
        //         path="/"    
        //         element={
        //             <ProtectedRoute 
        //                 children={
        //                     <Navigate to={`/${userRole?.toLocaleLowerCase()}`} />
        //                 }
        //             />    
        //         }
        //     />

        //     {/* AUTH ROUTES */}
        //     <Route 
        //         path="/login"
        //         element={ <LoginPage />}
        //     />

        //     <Route 
        //         path="/register"
        //         element={<RegistrationPage />}
        //     />

        //     <Route 
        //         path="/setpassword"
        //         element={<SetPasswordPage />}
        //     />


        //     {/* ADMIN ROUTES */}
        //     <Route 
        //         path="/admin"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Admin"]}
        //                 children={<AdminDashboard />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/admin/employees"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Admin"]}
        //                 children={<EmployeesPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/admin/stores"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Admin"]}
        //                 children={<AdminStoresPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/admin/more"
        //         element={
        //             <ProtectedRoute 
        //                 children={
        //                     <AdminLayout>
        //                         <MorePage />
        //                     </AdminLayout>
        //                 }
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/plans"
        //         element={
        //         <ProtectedRoute
        //             allowedRoles={["Admin"]}
        //             children={<PlansPage />}
        //         />
        //     }
        //     />
        


        //     {/* CASHIER ROUTES*/}
        //     <Route 
        //         path="/cashier"
        //         element={
        //             <ProtectedRoute
        //                 allowedRoles={["Cashier"]} 
        //                 children={<CashierItemsPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/cashier/customers"
        //         element={
        //             <ProtectedRoute
        //                 allowedRoles={["Cashier"]} 
        //                 children={<CashierCustomersPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/cashier/more"
        //         element={
        //             <ProtectedRoute
        //                 allowedRoles={["Cashier"]} 
        //                 children={
        //                     <CashierLayout>
        //                         <MorePage />
        //                     </CashierLayout>
        //                 }
        //             />
        //         }
        //     />


        //     {/* MANAGER ROUTES */}
        //      <Route 
        //         path="/manager"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Manager"]}
        //                 children={<ManagerDashboard />}
        //             />
        //         }
        //     />

        //      <Route 
        //         path="/manager/items"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Manager"]}
        //                 children={<ManagerStoreItemsPage />}
        //             />
        //         }
        //     />

        //      <Route 
        //         path="/manager/employees"
        //         element={
        //             <ProtectedRoute 
        //                 allowedRoles={["Manager"]}
        //                 children={<EmployeesPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/manager/more"
        //         element={
        //             <ProtectedRoute 
        //                 children={
        //                     <ManagerLayout>
        //                         <MorePage />
        //                     </ManagerLayout>
        //                 }
        //             />
        //         }
        //     />


        //     {/* GENERAL ROUTES */}

        //     <Route 
        //         path="*"
        //         element={ <NotFoundPage />}
        //     />

        //     <Route 
        //         path="/subscription"
        //         element={
        //             <ProtectedRoute 
        //                 children={
        //                     <RoleBasedLayout>
        //                         <SubscriptionPage />
        //                     </RoleBasedLayout>
        //                 }
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/notifications"
        //         element={
        //             <RoleBasedLayout>
        //                 <NotificationsPage />
        //             </RoleBasedLayout>
        //         }
        //     />

        //     <Route 
        //         path="/history/sales"
        //         element={
        //             <ProtectedRoute
        //                 children={<SalesHistoryPage />}
        //             />
        //         }
        //     />

        //     <Route 
        //         path="/history/products"
        //         element={
        //             <ProtectedRoute
        //                 children={<ProductSalesHistoryPage />}
        //             />
        //         }
        //     />

        // </Routes>

    <Routes>
        {/* PUBLIC ROUTES */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/setpassword" element={<SetPasswordPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* AUTHENTICATED ENTRY */}
        <Route element={<ProtectedRoute />}>
            {/* Onboarding route — outside AuthGate to avoid role-based redirects */}
            <Route path="/onboarding" element={<OnboardingPage />} />

            <Route element={<AuthGate />} >

                {/* ADMIN ROUTES */}
                <Route element={<ProtectedRoute allowedRoles={["Admin"]} />}>
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/employees" element={<EmployeesPage />} />
                    <Route path="/admin/stores" element={<AdminStoresPage />} />
                    <Route path="/admin/items" element={<ManagerStoreItemsPage />} />
                    <Route
                        path="/admin/more"
                        element={
                        <AdminLayout>
                            <MorePage />
                        </AdminLayout>
                        }
                    />
                    <Route path="/plans" element={<PlansPage />} />
                </Route>

                {/* CASHIER ROUTES */}
                <Route element={<ProtectedRoute allowedRoles={["Cashier"]} />}>
                    <Route path="/cashier" element={<CashierDashboard />} />
                    <Route path="/cashier/items" element={<CashierItemsPage />} />
                    <Route path="/cashier/customers" element={<CashierCustomersPage />} />
                    <Route
                        path="/cashier/more"
                        element={
                        <CashierLayout>
                            <MorePage />
                        </CashierLayout>
                        }
                    />
                </Route>

                {/* MANAGER ROUTES */}
                <Route element={<ProtectedRoute allowedRoles={["Manager"]} />}>
                    <Route path="/manager" element={<ManagerDashboard />} />
                    <Route path="/manager/items" element={<ManagerStoreItemsPage />} />
                    <Route path="/manager/employees" element={<EmployeesPage />} />
                    <Route
                        path="/manager/more"
                        element={
                        <ManagerLayout>
                            <MorePage />
                        </ManagerLayout>
                        }
                    />
                </Route>

                {/* SHARED ROUTES */}
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/history/sales" element={<SalesHistoryPage />} />
                <Route path="/history/products" element={<ProductSalesHistoryPage />} />
                <Route path="/test/sms" element={<TestSMSPage />} />
                <Route path="/settings" element={<SettingsPage />} />
            </Route>
        </Route>

        {/* SUPERADMIN ROUTES */}
        <Route path="/superadmin/login" element={<SuperAdminLogin />} />
        <Route element={<SuperAdminRoute />}>
            <Route path="/superadmin/dashboard" element={<SuperAdminDashboard />} />
            <Route path="/superadmin/users" element={<SuperAdminUsers />} />
            <Route path="/superadmin/users/:id" element={<SuperAdminUserDetail />} />
            <Route path="/superadmin/businesses" element={<SuperAdminBusinesses />} />
            <Route path="/superadmin/businesses/:id" element={<SuperAdminBusinessDetail />} />
            <Route path="/superadmin/stores" element={<SuperAdminStores />} />
            <Route path="/superadmin/subscriptions" element={<SuperAdminSubscriptions />} />
            <Route path="/superadmin/audit-log" element={<SuperAdminAuditLog />} />
        </Route>

        {/* FALLBACK */}
        <Route path="*" element={<NotFoundPage />} />
    </Routes>

     );
}
 
export default AppRoutes;